import type { InjectionKey } from 'vue'

export interface AcceptanceSurfaceSlice {
  controlsExpanded?: boolean
  developerEntry?: 'absent' | 'visible'
  developerEntryReason?: 'development-build' | 'devtools-flag' | 'production-build'
  openSettings?: 'hidden' | 'visible'
  settingsRoute?: string
  workbenchPanel?: 'diagnosis' | 'sessions' | 'timeline'
}

export interface AcceptanceSurfacePublisher {
  publish: (slice: AcceptanceSurfaceSlice) => Promise<void>
}

/** The desktop application owns IPC. Surfaces publish only the fields they own. */
export const acceptanceSurfacePublisherKey: InjectionKey<AcceptanceSurfacePublisher> = Symbol('acceptance-surface-publisher')
